import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#3AAF58', blue:'#FFFFFF', blueLight:'#FFFFFF',
 red:'#E05050', redBg:'rgba(224,80,80,.10)', redBorder:'rgba(224,80,80,.25)',
 amber:'#D4840F', amberBg:'rgba(212,132,15,.10)', amberBorder:'rgba(212,132,15,.25)',
 green:'#3AAF58', greenBg:'rgba(58,175,88,.10)', greenBorder:'rgba(58,175,88,.25)',
 purple:'#8060C0',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});
const fmtDate = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';

const BOOKING_TYPES = [' Room Stay',' Day Picnic',' Event / Wedding',' Corporate / MICE',' School Picnic'];
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const inp = { width:'100%', padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none' };
const sel = { ...inp, cursor:'pointer' };

function Modal({ title, onClose, children, maxWidth=560 }) {
 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth, maxHeight:'90vh', overflow:'auto' }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'18px 22px', borderBottom:'1px solid rgba(255,255,255,.08)' }}>
 <div style={{ fontWeight:700, fontSize:15, color:'#F0F2FF' }}>{title}</div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'#606880', fontSize:20, cursor:'pointer' }}></button>
 </div>
 <div style={{ padding:22 }}>{children}</div>
 </div>
 </div>
 );
}

// ── LEADERBOARD TAB ───────────────────────────────────────────────────────────
function LeaderboardTab() {
 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(true);
 const [year, setYear] = useState(new Date().getFullYear());

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const res = await fetch(`${API}/sales/leaderboard?year=${year}`);
 const d = await res.json();
 setData(Array.isArray(d) ? d : []);
 } catch {}
 finally { setLoading(false); }
 }, [year]);

 useEffect(() => { load(); }, [load]);

 const medals = ['','',''];
 const maxRev = Math.max(...data.map(d => parseFloat(d.total_revenue||0)), 1);

 return (
 <div>
 <div style={{ display:'flex', gap:10, marginBottom:20, alignItems:'center' }}>
 <select value={year} onChange={e=>setYear(e.target.value)} style={{ ...sel, width:120 }}>
 {[2024,2025,2026,2027].map(y=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={y}>{y}</option>)}
 </select>
 <button onClick={load} style={{ padding:'10px 16px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}> Refresh</button>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <div style={{ display:'grid', gap:12 }}>
 {data.length === 0 && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>No sales data for {year}</div>}
 {data.map((sp, i) => {
 const rev = parseFloat(sp.total_revenue || 0);
 const pct = Math.round(rev / maxRev * 100);
 return (
 <div key={sp.salesperson} style={{ background:i===0?`${C.accent}15`:C.surface, border:`1px solid ${i===0?C.accent:C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
 <div style={{ display:'flex', alignItems:'center', gap:12 }}>
 <div style={{ fontSize:28 }}>{medals[i] || `#${i+1}`}</div>
 <div>
 <div style={{ fontWeight:800, fontSize:16, color:C.text }}>{sp.salesperson}</div>
 <div style={{ fontSize:12, color:C.text2 }}>{sp.total_bookings} bookings · {sp.confirmed_bookings} confirmed</div>
 </div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontSize:22, fontWeight:900, color:i===0?C.accent:C.text }}>{inr(rev)}</div>
 <div style={{ fontSize:12, color:C.text2 }}>Total Revenue</div>
 </div>
 </div>
 <div style={{ height:6, background:'rgba(255,255,255,.06)', borderRadius:99 }}>
 <div style={{ height:6, width:`${pct}%`, background:`linear-gradient(90deg,${C.accent},#50D080)`, borderRadius:99, transition:'width .5s' }} />
 </div>
 </div>
 );
 })}
 </div>
 )}
 </div>
 );
}

// ── PERFORMANCE TAB ───────────────────────────────────────────────────────────
function PerformanceTab() {
 const [data, setData] = useState(null);
 const [loading, setLoading] = useState(true);
 const [month, setMonth] = useState(new Date().getMonth()+1);
 const [year, setYear] = useState(new Date().getFullYear());

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const res = await fetch(`${API}/sales/performance?month=${month}&year=${year}`);
 const d = await res.json();
 setData(d);
 } catch {}
 finally { setLoading(false); }
 }, [month, year]);

 useEffect(() => { load(); }, [load]);

 return (
 <div>
 <div style={{ display:'flex', gap:10, marginBottom:20, alignItems:'center' }}>
 <select value={month} onChange={e=>setMonth(e.target.value)} style={{ ...sel, width:120 }}>
 {MONTHS.map((m,i)=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={i+1} value={i+1}>{m}</option>)}
 </select>
 <select value={year} onChange={e=>setYear(e.target.value)} style={{ ...sel, width:100 }}>
 {[2024,2025,2026,2027].map(y=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={y}>{y}</option>)}
 </select>
 <button onClick={load} style={{ padding:'10px 16px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}> Refresh</button>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && data && (
 <>
 {/* Performance Cards */}
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:14, marginBottom:24 }}>
 {(data.performance||[]).map(sp => {
 const achPct = sp.target ? Math.min(Math.round(sp.total_revenue/sp.target*100),100) : null;
 return (
 <div key={sp.salesperson} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 }}>
 <div>
 <div style={{ fontSize:32, marginBottom:6 }}>
 {sp.salesperson.split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase()}
 </div>
 <div style={{ fontWeight:700, fontSize:15, color:C.text }}>{sp.salesperson}</div>
 <div style={{ fontSize:12, color:C.text2 }}>{sp.bookings?.length||0} bookings this month</div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontSize:20, fontWeight:900, color:C.accent }}>{inr(sp.total_revenue)}</div>
 <div style={{ fontSize:12, color:C.green }}>+{inr(Math.round(sp.incentive_earned||0))} incentive</div>
 </div>
 </div>

 {sp.target && (
 <>
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:C.text2, marginBottom:6 }}>
 <span>Target: {inr(sp.target)}</span>
 <span style={{ fontWeight:700, color:achPct>=100?C.green:achPct>=70?C.amber:C.red }}>{achPct}%</span>
 </div>
 <div style={{ height:8, background:'rgba(255,255,255,.06)', borderRadius:99, marginBottom:14 }}>
 <div style={{ height:8, width:`${achPct}%`, background:achPct>=100?`linear-gradient(90deg,${C.accent},#50D080)`:achPct>=70?`linear-gradient(90deg,${C.amber},#F0C040)`:`linear-gradient(90deg,${C.red},#F07070)`, borderRadius:99, transition:'width .5s' }} />
 </div>
 </>
 )}

 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
 {[
 {label:'Revenue', value:inr(sp.total_revenue), color:C.accent},
 {label:'Incentive', value:inr(Math.round(sp.incentive_earned||0)), color:C.green},
 {label:'Bookings', value:sp.bookings?.length||0, color:C.blueLight},
 {label:'Confirmed', value:sp.bookings?.filter(b=>b.booking_status==='Confirmed').length||0, color:C.text2},
 ].map(s=>(
 <div key={s.label} style={{ background:C.surface2, borderRadius:8, padding:'10px 12px', textAlign:'center' }}>
 <div style={{ fontSize:16, fontWeight:800, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:2 }}>{s.label}</div>
 </div>
 ))}
 </div>
 </div>
 );
 })}
 {(data.performance||[]).length===0 && <div style={{ textAlign:'center', padding:40, color:C.text2, gridColumn:'span 3' }}>No sales data for this month</div>}
 </div>

 {/* Bookings Table */}
 {(data.bookings||[]).length > 0 && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, overflow:'hidden' }}>
 <div style={{ padding:'14px 18px', borderBottom:`1px solid ${C.border}`, fontWeight:700, fontSize:14 }}>All Bookings This Month</div>
 <div style={{ overflowX:'auto' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Code','Guest','Type','Amount','Status','Salesperson','Date'].map(h=>(
 <th key={h} style={{ padding:'10px 14px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', textTransform:'uppercase', letterSpacing:'.05em', whiteSpace:'nowrap' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.bookings.map((b,i)=>(
 <tr key={i} style={{ borderBottom:'1px solid rgba(255,255,255,.04)' }}>
 <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:C.accent }}>{b.booking_code}</td>
 <td style={{ padding:'10px 14px', fontSize:13, color:C.text }}>{b.guest_name||'—'}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.booking_type}</td>
 <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:C.accent }}>{inr(b.total_amount)}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.booking_status}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.salesperson||'—'}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{fmtDate(b.created_at)}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </div>
 )}
 </>
 )}
 </div>
 );
}

// ── INCENTIVE SETTINGS TAB ────────────────────────────────────────────────────
function IncentiveSettingsTab() {
 const [incentives, setIncentives] = useState([]);
 const [targets, setTargets] = useState([]);
 const [users, setUsers] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showIncForm, setShowIncForm] = useState(false);
 const [showTargetForm, setShowTargetForm] = useState(false);
 const [incForm, setIncForm] = useState({ booking_type:' Room Stay', incentive_pct:2, quarterly_bonus_pct:0.5, effective_from:new Date().toISOString().slice(0,10) });
 const [targetForm, setTargetForm] = useState({ salesperson_id:'', month:new Date().getMonth()+1, year:new Date().getFullYear(), target_amount:500000 });
 const [editInc, setEditInc] = useState(null);

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const [inc, tgt, usr] = await Promise.all([
 fetch(`${API}/sales/incentives`).then(r=>r.json()),
 fetch(`${API}/sales/targets`).then(r=>r.json()),
 fetch(`${API}/sessions/users`).then(r=>r.json()),
 ]);
 setIncentives(Array.isArray(inc)?inc:[]);
 setTargets(Array.isArray(tgt)?tgt:[]);
 setUsers(Array.isArray(usr)?usr.filter(u=>u.role==='Sales & CRM'||u.role==='General Manager'):[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const saveIncentive = async () => {
 if (editInc) {
 await fetch(`${API}/sales/incentives/${editInc.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body:JSON.stringify(incForm) });
 } else {
 await fetch(`${API}/sales/incentives`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(incForm) });
 }
 setShowIncForm(false); setEditInc(null); load();
 };

 const saveTarget = async () => {
 await fetch(`${API}/sales/targets`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(targetForm) });
 setShowTargetForm(false); load();
 };

 return (
 <div>
 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <>
 {/* Incentive Structure */}
 <div style={{ marginBottom:28 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text }}> Incentive Structure by Booking Type</div>
 <button onClick={()=>{setEditInc(null);setIncForm({booking_type:' Room Stay',incentive_pct:2,quarterly_bonus_pct:0.5,effective_from:new Date().toISOString().slice(0,10)});setShowIncForm(true)}}
 style={{ padding:'8px 16px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Add Rate</button>
 </div>
 {incentives.length===0
 ? <div style={{ padding:20, background:C.surface2, borderRadius:10, color:C.text3, fontSize:13, textAlign:'center' }}>No incentive rates set. Click + Add Rate to set up.</div>
 : (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Booking Type','Incentive %','Quarterly Bonus %','Effective From','Actions'].map(h=>(
 <th key={h} style={{ padding:'10px 14px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', textTransform:'uppercase', letterSpacing:'.05em' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {incentives.map(inc=>(
 <tr key={inc.id} style={{ borderBottom:'1px solid rgba(255,255,255,.04)' }}>
 <td style={{ padding:'12px 14px', fontWeight:600, color:C.text }}>{inc.booking_type}</td>
 <td style={{ padding:'12px 14px', fontSize:15, fontWeight:800, color:C.accent }}>{inc.incentive_pct}%</td>
 <td style={{ padding:'12px 14px', fontSize:14, fontWeight:700, color:C.purple }}>{inc.quarterly_bonus_pct}%</td>
 <td style={{ padding:'12px 14px', fontSize:12, color:C.text2 }}>{inc.effective_from?.slice(0,10)}</td>
 <td style={{ padding:'12px 14px' }}>
 <button onClick={()=>{setEditInc(inc);setIncForm({booking_type:inc.booking_type,incentive_pct:inc.incentive_pct,quarterly_bonus_pct:inc.quarterly_bonus_pct,effective_from:inc.effective_from?.slice(0,10)});setShowIncForm(true)}}
 style={{ padding:'4px 12px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:6, color:'#3B82F6', cursor:'pointer', fontSize:12 }}> Edit</button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 )}
 </div>

 {/* Monthly Targets */}
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text }}> Monthly Targets</div>
 <button onClick={()=>setShowTargetForm(true)}
 style={{ padding:'8px 16px', background:C.blue, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Set Target</button>
 </div>
 {targets.length===0
 ? <div style={{ padding:20, background:C.surface2, borderRadius:10, color:C.text3, fontSize:13, textAlign:'center' }}>No targets set. Click + Set Target to assign monthly targets.</div>
 : (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Salesperson','Month','Year','Target Amount'].map(h=>(
 <th key={h} style={{ padding:'10px 14px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', textTransform:'uppercase', letterSpacing:'.05em' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {targets.map(t=>(
 <tr key={t.id} style={{ borderBottom:'1px solid rgba(255,255,255,.04)' }}>
 <td style={{ padding:'12px 14px', fontWeight:600, color:C.text }}>{t.salesperson_name}</td>
 <td style={{ padding:'12px 14px', color:C.text2 }}>{MONTHS[t.month-1]}</td>
 <td style={{ padding:'12px 14px', color:C.text2 }}>{t.year}</td>
 <td style={{ padding:'12px 14px', fontSize:15, fontWeight:800, color:C.accent }}>{inr(t.target_amount)}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 )}
 </div>
 </>
 )}

 {/* Incentive Form */}
 {showIncForm && (
 <Modal title={editInc?'Edit Incentive Rate':'Add Incentive Rate'} onClose={()=>{setShowIncForm(false);setEditInc(null);}}>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Booking Type</label>
 <select value={incForm.booking_type} onChange={e=>setIncForm(p=>({...p,booking_type:e.target.value}))} style={sel}>
 {BOOKING_TYPES.map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t}>{t}</option>)}
 </select>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Incentive % (per booking)</label>
 <input style={inp} type="number" min={0} max={10} step={0.5} value={incForm.incentive_pct} onChange={e=>setIncForm(p=>({...p,incentive_pct:e.target.value}))} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Quarterly Bonus %</label>
 <input style={inp} type="number" min={0} max={5} step={0.25} value={incForm.quarterly_bonus_pct} onChange={e=>setIncForm(p=>({...p,quarterly_bonus_pct:e.target.value}))} />
 </div>
 </div>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Effective From</label>
 <input style={inp} type="date" value={incForm.effective_from} onChange={e=>setIncForm(p=>({...p,effective_from:e.target.value}))} />
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>{setShowIncForm(false);setEditInc(null);}} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={saveIncentive} style={{ padding:'10px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Save</button>
 </div>
 </Modal>
 )}

 {/* Target Form */}
 {showTargetForm && (
 <Modal title="Set Monthly Target" onClose={()=>setShowTargetForm(false)}>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Salesperson</label>
 <select value={targetForm.salesperson_id} onChange={e=>setTargetForm(p=>({...p,salesperson_id:e.target.value}))} style={sel}>
 <option style={{background:'#0F2040',color:'#F0F2FF'}} value="">Select salesperson</option>
 {users.map(u=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={u.id} value={u.id}>{u.name}</option>)}
 </select>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Month</label>
 <select value={targetForm.month} onChange={e=>setTargetForm(p=>({...p,month:e.target.value}))} style={sel}>
 {MONTHS.map((m,i)=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={i+1} value={i+1}>{m}</option>)}
 </select>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Year</label>
 <select value={targetForm.year} onChange={e=>setTargetForm(p=>({...p,year:e.target.value}))} style={sel}>
 {[2025,2026,2027].map(y=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={y}>{y}</option>)}
 </select>
 </div>
 </div>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Monthly Target (₹)</label>
 <input style={inp} type="number" value={targetForm.target_amount} onChange={e=>setTargetForm(p=>({...p,target_amount:e.target.value}))} />
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>setShowTargetForm(false)} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={saveTarget} style={{ padding:'10px 22px', background:C.blue, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Set Target</button>
 </div>
 </Modal>
 )}
 </div>
 );
}

// ── MY PERFORMANCE (Salesperson view) ─────────────────────────────────────────
function MyPerformanceTab() {
 const [data, setData] = useState(null);
 const [loading, setLoading] = useState(true);

 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const myName = currentUser?.name || '';

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const m = new Date().getMonth()+1;
 const y = new Date().getFullYear();
 const res = await fetch(`${API}/sales/performance?month=${m}&year=${y}&salesperson=${encodeURIComponent(myName)}`);
 const d = await res.json();
 setData(d);
 } catch {}
 finally { setLoading(false); }
 }, [myName]);

 useEffect(() => { load(); }, [load]);

 const myPerf = data?.performance?.[0];

 return (
 <div>
 <div style={{ background:`linear-gradient(135deg,#192D1F,#1A2E1A)`, borderRadius:16, padding:24, marginBottom:24 }}>
 <div style={{ fontSize:11, color:'rgba(255,255,255,.4)', textTransform:'uppercase', letterSpacing:'.1em', marginBottom:4 }}>My Sales Performance</div>
 <div style={{ fontSize:26, fontWeight:900, color:'#fff', marginBottom:2 }}>{myName}</div>
 <div style={{ fontSize:13, color:'rgba(255,255,255,.5)' }}>{MONTHS[new Date().getMonth()]} {new Date().getFullYear()}</div>
 {myPerf && (
 <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginTop:20 }}>
 {[
 {label:'Revenue', value:inr(myPerf.total_revenue), color:'#3AAF58'},
 {label:'Incentive', value:inr(Math.round(myPerf.incentive_earned)), color:'#50D080'},
 {label:'Bookings', value:myPerf.bookings?.length||0, color:'rgba(255,255,255,.8)'},
 {label:'Target', value:myPerf.target?inr(myPerf.target):'Not set', color:'#D4840F'},
 ].map(s=>(
 <div key={s.label} style={{ background:'rgba(255,255,255,.07)', borderRadius:12, padding:'14px' }}>
 <div style={{ fontSize:20, fontWeight:900, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:10, color:'rgba(255,255,255,.4)', textTransform:'uppercase', letterSpacing:'.06em', marginTop:4 }}>{s.label}</div>
 </div>
 ))}
 </div>
 )}
 {myPerf?.target && (
 <div style={{ marginTop:16 }}>
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'rgba(255,255,255,.5)', marginBottom:6 }}>
 <span>Target Achievement</span>
 <span style={{ color:'#3AAF58', fontWeight:700 }}>{myPerf.achievement_pct}%</span>
 </div>
 <div style={{ height:8, background:'rgba(255,255,255,.1)', borderRadius:99 }}>
 <div style={{ height:8, width:`${Math.min(myPerf.achievement_pct,100)}%`, background:'linear-gradient(90deg,#3AAF58,#50D080)', borderRadius:99 }} />
 </div>
 </div>
 )}
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && data && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, overflow:'hidden' }}>
 <div style={{ padding:'14px 18px', borderBottom:`1px solid ${C.border}`, fontWeight:700, fontSize:14 }}>My Bookings This Month</div>
 {(data.bookings||[]).length===0
 ? <div style={{ textAlign:'center', padding:40, color:C.text2 }}>No bookings this month</div>
 : (
 <div style={{ overflowX:'auto' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Code','Guest','Type','Amount','Incentive','Status','Date'].map(h=>(
 <th key={h} style={{ padding:'10px 14px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', textTransform:'uppercase', letterSpacing:'.05em', whiteSpace:'nowrap' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.bookings.map((b,i)=>{
 const incPct = 2; // default
 const incAmt = Math.round(parseFloat(b.total_amount||0)*incPct/100);
 return (
 <tr key={i} style={{ borderBottom:'1px solid rgba(255,255,255,.04)' }}>
 <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:C.accent }}>{b.booking_code}</td>
 <td style={{ padding:'10px 14px', fontSize:13, color:C.text }}>{b.guest_name||'—'}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.booking_type}</td>
 <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:C.accent }}>{inr(b.total_amount)}</td>
 <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:C.green }}>{inr(incAmt)}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.booking_status}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{fmtDate(b.created_at)}</td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 )}
 </div>
 )}
 </div>
 );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function SalesPerformance() {
 const [tab, setTab] = useState('leaderboard');

 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const isSales = currentUser?.roleKey === 'SALES';
 const isAdmin = currentUser?.roleKey === 'SUPER_ADMIN' || currentUser?.roleKey === 'ADMIN' || currentUser?.roleKey === 'RESORT_GM';

 const TABS = [
 ...(isSales ? [{ id:'mine', label:' My Performance' }] : []),
 { id:'leaderboard', label:' Leaderboard' },
 { id:'performance', label:' Team Performance' },
 ...(isAdmin ? [{ id:'settings', label:' Incentive Settings' }] : []),
 ];

 return (
 <div style={{ padding:24, background:C.bg, minHeight:'100vh', color:C.text, fontFamily:'Inter,sans-serif' }}>
 <div style={{ marginBottom:24 }}>
 <div style={{ fontSize:22, fontWeight:800 }}> Sales Performance & Incentives</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:2 }}>Track performance, targets and incentive earnings</div>
 </div>

 {/* Tabs */}
 <div style={{ display:'flex', gap:4, marginBottom:24, background:C.surface, borderRadius:10, padding:4, width:'fit-content' }}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{ padding:'8px 18px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, fontWeight:600, background:tab===t.id?C.accent:'transparent', color:tab===t.id?'#fff':C.text2, whiteSpace:'nowrap' }}>
 {t.label}
 </button>
 ))}
 </div>

 {tab==='mine' && <MyPerformanceTab />}
 {tab==='leaderboard' && <LeaderboardTab />}
 {tab==='performance' && <PerformanceTab />}
 {tab==='settings' && <IncentiveSettingsTab />}
 </div>
 );
}
